export enum OrderBy {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface SortCriteria<T> {
  sortField: keyof T;
  orderBy: OrderBy;
}
